module.exports = __webpack_public_path__ + "static/media/HybridBarleyIcon.fc5a3db3.svg";